import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    allUserInfo: null,
    isLoggedIn: false,
    customerAccessToken: '',
    authToken: '',
    loginEmail: '',
    customerName: '',
    phoneNumber: '',
    cartQuantity: '',
    currentBranchId: '',
    currentDebtorId: '',
    draftOrderID: '',
    isChameleonCalled: false,
    hook_url: '',
    currentVersion: '',
    productList: '',
    myProduct: '',
    receiverList: '',
    cartProductsDetails: '',
    grandTotalAmount: '',
    cartProjectType: '',
    receiverId: '',
}

const userSlice = createSlice({
    name: 'auth', initialState, reducers: {
        loginUser(state, action) {
            const payload = action.payload;
            state.isLoggedIn = true;
            state.customerAccessToken = payload.accessToken;
            state.loginEmail = payload.email;
            state.authToken = payload.authToken;
        }, logoutUser(state) {
            state.isLoggedIn = false;
            state.customerAccessToken = '';
            state.loginEmail = '';
            state.allUserInfo = null;
            state.authToken = '';
            state.cartQuantity = '';
            state.currentBranchId = '';
            state.currentDebtorId = '';
            state.draftOrderID = '';
            state.hook_url = '';
            state.productList = '';
            state.checkoutDetails = '';
        }, setUserName(state, action) {
            const payload = action.payload;
            state.customerName = payload.name
        }, setAllUserInfo(state, action) {
            const payload = action.payload;
            state.allUserInfo = payload.userInfo;
        }, setPhoneNumber(state, action) {
            const payload = action.payload;
            state.phoneNumber = payload.phone
        }, setDefaultAddress(state, action) {
            const payload = action.payload;
            if (state.allUserInfo === null) {
                state.allUserInfo = payload;
            }
            if (!state.allUserInfo['address']) state.allUserInfo['address'] = payload.address1;
            if (!state.allUserInfo['city']) state.allUserInfo['city'] = payload.city;
            if (!state.allUserInfo['country']) state.allUserInfo['country'] = payload.country;
            if (!state.allUserInfo['zip']) state.allUserInfo['zip'] = payload.zip;
        }, setCartID(state, action) {
            const payload = action.payload;
            if (state.allUserInfo) {
                state.allUserInfo.cart_id = payload.currentCartID;
            }
        }, setGlobalCartQuantity(state, action) {
            const payload = action.payload;
            state.cartQuantity = payload.cartQuantity;
        }, setCurrentBranchID(state, action) {
            const payload = action.payload;
            state.currentBranchId = payload.currentBranchId;
            state.currentDebtorId = payload.currentDebtorId;
        }, setDraftOrderID(state, action) {
            const payload = action.payload;
            state.draftOrderID = payload.draftOrderID;
        }, setIsChameleonCalled(state, action) {
            const payload = action.payload;
            state.isChameleonCalled = payload.isChameleonCalled;
        }, setHookUrl(state, action) {
            const payload = action.payload;
            state.hook_url = payload.hook_url;
        }, setCurrentVersion(state, action) {
            const payload = action.payload;
            state.currentVersion = payload.currentVersion;
        }, setGlobalCartProductItems(state, action) {
            const payload = action.payload;
            state.productList = payload.productList;
        }, setGlobalMyProduct(state, action) {
            const payload = action.payload;
            state.myProduct = payload.myProduct;
        }, setGlobalReceiverList( state, action) {
            const payload = action.payload;
            state.receiverList = payload.receiverList;
        }, setGlobalCartProductsDetails( state, action) {
            const payload = action.payload;
            state.cartProductsDetails = payload.cartProductsDetails;
        }, setGlobalGrandTotalPrice(state, action) {
            const payload = action.payload;
            state.grandTotalAmount = payload.grandTotalAmount;
        }, setGlobaldefaultContactId(state, action) {
            const payload = action.payload;
            state.defaultContactId = payload.defaultContactId;            
        }, setGlobalCartProjectType(state, action) {
            const payload = action.payload;
            state.cartProjectType = payload.cartProjectType;            
        },
        setGlobalReceiverId(state, action) {
            const payload = action.payload;
            state.receiverId = payload.receiverId;
        },
        setGlobalThankyouDetails( state, action) {
            const payload = action.payload;
            state.checkoutDetails = payload.checkoutDetails;
        },
        setGlobalDrillCartInfo( state, action) {
            const payload = action.payload;
            state.drillCartInfo = payload.drillCartInfo;
        },
    }
});

export const {
    setCartID,
    loginUser,
    logoutUser,
    setUserName,
    setPhoneNumber,
    setAllUserInfo,
    setDraftOrderID,
    setDefaultAddress,
    setCurrentBranchID,
    setIsChameleonCalled,
    setGlobalCartQuantity,
    setHookUrl,
    setCurrentVersion,
    setGlobalCartProductItems,
    setGlobalMyProduct,
    setGlobalReceiverList,
    setGlobalCartProductsDetails,
    setGlobalThankyouDetails,
    setGlobalGrandTotalPrice,
    setGlobalCartProjectType,
    setGlobaldefaultContactId,
    setGlobalReceiverId,
    setGlobalDrillCartInfo
} = userSlice.actions;

export default userSlice;
